<template>
  <div class="formGroup">
    <p class="formGroupText" v-if="label">
      <span>
        {{ label }}
        <span class="patternLabel" v-if="patternLabel">
          *{{ patternLabel }}
        </span>
      </span>
      <LabelRequire v-if="req" />
      <LabelOptional v-if="optional" />
    </p>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import LabelRequire from '@/components/elements/LabelRequire.vue'
import LabelOptional from '@/components/elements/LabelOptional.vue'
import { SetupContext } from 'vue'

export default {
  name: 'FormSelectField',

  components: {
    LabelRequire,
    LabelOptional
  },

  props: {
    label: String,
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const changeSelect = (value: string) => {
      context.emit('change-message', value)
    }

    return {
      changeSelect
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.formGroup {
  &:not(:first-child) {
    margin-top: 32px;
  }

  &:not(:last-child) {
    margin-bottom: 32px;
  }
}

.formGroupText {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  font-weight: 500;
  margin-bottom: 10px;

  @include mixins.media() {
    width: calc(37.5% - 20px);
    max-width: calc(37.5% - 20px);
    flex-basis: calc(37.5% - 20px);
  }

  span {
    line-height: 1.4;
  }
}

.patternLabel {
  margin-left: 5px;
  font-size: 1rem;
  display: inline-block;
}
</style>
